(function () {
  'use strict';

  /* @ngdoc object
   * @name individualCrewScheduleReport
   * @description
   *
   */
  angular
    .module('individualCrewScheduleReport', [
      'ui.router'
    ]);
}());
